import styled from 'styled-components';

export const StyledDetailsWrapper = styled.div`
    display: flex;
    align-items: center;
    color: ${({ theme }) => theme.colors.correct};
    font-weight: bold;
    cursor: pointer;
`;

export const StyledLeftSection = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const StyledSquare = styled.div<{ type?: 'correct' | 'warning' | 'error' }>`
    width: 8px;
    height: 14px;
    border: none;
    background-color: ${({ type, theme }) => theme.colors[type || 'correct']};
`;

export const StyledPayloadType = styled.label`
    font-weight: bold;
    margin: 0 16px;
`;

export const StyledOutOfStock = styled(StyledPayloadType)`
    color: ${({ theme }) => theme.colors.error};
`;
